export default "__VITE_PUBLIC_ASSET__63cc94d5__"